import "./styles.scss";

import { cdnURL } from "components/utils/cdn";
import { useMember } from "hooks/member";
import { usePremiumOffers } from "hooks/payment";
import React from "react";
import { useNavigate } from "react-router-dom";

const TrialBenefits = () => {
  const navigate = useNavigate();
  const { memberId, isMember, membershipInfo } = useMember();
  const { isPremium } = membershipInfo || {};
  const { premiumOffers, getPremiumOffersPending } = usePremiumOffers();

  const onRegisterClick = () => {
    navigate("/register");
  };

  const onPayClick = () => {
    navigate("/payment?action=pay");
  };

  const removeTrailingZeros = (num, decimals) => {
    const number = parseFloat(num);
    return parseFloat(number.toFixed(decimals));
  };

  if (getPremiumOffersPending || premiumOffers.length === 0 || isPremium) {
    return null;
  }

  const hasTrialOffer = premiumOffers.some((o) => !!o.trialPeriodDays);
  const sortedOffers = [...premiumOffers].sort((a, b) => (Number(a.amount) < Number(b.amount) ? -1 : 1));

  return (
    <div className="trial-benefits">
      <h2 className="trial-benefits-title">Upgrade to Premium and enjoy access to our full collection of 4500+ cards</h2>
      {hasTrialOffer && <p className="trial-benefits-subtitle">Our 30-day free trial* allows you to try us out with no strings attached.</p>}
      <ul className="offers-list">
        <li className="offer-item">
          <div className="offer-header">
            <div className="offer-price">
              <sup className="offer-currency">{premiumOffers[0].currencySymbol}</sup>
              <span className="offer-value">0</span>
            </div>
            <div className="offer-duration">always free</div>
            <div className="offer-pill">free</div>
            <div className="offer-info">&nbsp;</div>
            {!(memberId || isMember) ? (
              <div className="offer-callout" onClick={onRegisterClick}>
                create a free account
              </div>
            ) : (
              <div className="offer-callout white">your current benefits:</div>
            )}
          </div>
          <div className="offer-benefit">Send unlimited free cards</div>
          <div className="offer-benefit">Add unlimited reminders</div>
          <div className="offer-benefit">Add unlimited contacts</div>
          <div className="offer-benefit">Ad free</div>
          <div className="offer-benefit">Customer support</div>
        </li>
        {sortedOffers.map((o) => (
          <li className="offer-item" key={`offer-item-${o.stripePlanId}`}>
            {o.trialPeriodDays && (
              <img className="trial-badge" src={cdnURL("img/rebuild/promote/homepage/free-trial-badge.png")} width="176" height="175" alt="30-day free trial" />
            )}
            <div className="offer-header">
              <div className="offer-price">
                <sup className="offer-currency">{o.currencySymbol}</sup>
                <span className="offer-value">{removeTrailingZeros(o.amount, 2)}</span>
              </div>
              <div className="offer-duration">per {o.planInterval}</div>
              <div className="offer-pill">premium</div>
              {o.trialPeriodDays ? (
                <div className="offer-info">
                  (billed {o.planInterval}ly, after {o.trialPeriodDays}-day free trial)
                </div>
              ) : (
                <div className="offer-info">
                  ({o.planInterval === "year" ? `billed ${o.planInterval}ly, best value` : `billed ${o.planInterval}ly, cancel anytime`})
                </div>
              )}
              <div className="offer-callout" onClick={onPayClick}>
                go premium
              </div>
            </div>
            <div className="offer-benefit callout">Unlimited access to all cards</div>
            <div className="offer-benefit">Add unlimited reminders</div>
            <div className="offer-benefit">Add unlimited contacts</div>
            <div className="offer-benefit">Ad free</div>
            <div className="offer-benefit">Customer support</div>
            <div className="offer-benefit callout">Secure payment</div>
            {o.trialPeriodDays && (
              <div className="offer-benefit callout-extra">
                <span>{o.trialPeriodDays}-day free trial</span>
                <span className="offer-benefit-subtitle">60-day money back guarantee</span>
              </div>
            )}
          </li>
        ))}
      </ul>
      {!(memberId || isMember) && <p className="disclaimer">*The 30-day free trial is only available for new subscribers on the yearly plan.</p>}
    </div>
  );
};

export default TrialBenefits;
